<!--
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
-->
<button class="app" mat-menu-item (click)="openLinkInNewTab(item.url)">
  <!-- <div class="app-logo" style="background-image: url('../../../../assets/{{item.appname}}.png');"></div> -->
  <img src="/portal/assets/{{ item.iconName }}" alt="Logo" />
  <div class="app-name">{{ item.name }}</div>
  <button
    mat-button
    [matMenuTriggerFor]="menu"
    class="dotMenu"
    [matMenuTriggerData]="item"
    (click)="stopPropagation($event)"
  >
    <mat-icon>more_vert</mat-icon>
  </button>
</button>

<!-- Dot Menu dropdown -->
<mat-menu #menu="matMenu">
  <ng-template matMenuContent let-id="id" let-url="url" let-isFavorite="isFavorite">
    <button mat-menu-item class="dot-menu-item" (click)="openLinkInNewTab(url)">
      <span>Open in new tab</span>
    </button>
    <button mat-menu-item class="dot-menu-item" (click)="updateFavoriteApp(id, isFavorite)">
      <span *ngIf="!isFavorite">Add to Favorites</span>
      <span *ngIf="isFavorite">Remove from Favorites</span>
    </button>
  </ng-template>
</mat-menu>
